import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams, useLocation } from "react-router-dom";
import { getCustomerForUI } from "../../store/reducer/customers/customersSlice";
import {
  getCustomerForUI660
} from "../../store/reducer/drawing/drawingSlice";

import {
  getExpenseSnags,
  deleteExpenseSnag,
} from "../../store/reducer/drawing/drawingSlice";
import Notes from "../Notes/Notes";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import DrawingTabs from "./DrawingTabs";

function ExpenseSnagsList() {
  const { id, drawing_id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const [opportunityData, setOpportunityData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [customer_id, setCustomerId] = useState(null);

  useEffect(() => {
    setLoading(true);
    dispatch(getExpenseSnags({ customer_id,page, limit })).then((result) => {
      if (result.payload) {
        setCustomerData(result.payload.data.rows);
        setLoading(false);
      }
    });
   dispatch(getCustomerForUI660()).then((result) => {
          if (result.payload) {
            setCustomer(result.payload.data);
            setLoading(false);
          }
        });
  }, []);

  const handlePageClick = ({ selected }) => {
    const page = selected + 1;
    setPage(page);
    setLimit(10);
    dispatch(getExpenseSnags({ page, limit }));
  };

  const handleDeleteExpenseSnag = (id) => {
    if (window.confirm("Are you sure you want to delete this expense snag?")) {
      dispatch(deleteExpenseSnag(id))
        .then(() => {
          toast.success("Expense Snag deleted!");
        })
        .catch((error) => {
          alert("Failed to delete expense snag. Please try again.");
        });

      dispatch(getExpenseSnags()).then((result) => {
        setLoading(true);
        if (result.payload) {
          setCustomerData(result.payload.data.rows);
          setLoading(false);
        }
      });
    }
  };

  const getCustomer = (customer_id) => {
    setCustomerId(customer_id);
    dispatch(getExpenseSnags({ customer_id, page, limit }))
      .then((result) => {
        if (result.payload && result.payload.data) {
          setCustomerData(result.payload.data.rows);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="grid grid-cols-3 items-center mb-[30px]">
        <div className="flex gap-[16px] items-center">
          <Link to={`/opportunity/${id}`}>
            <div className="bg-[#F8F8F8] rounded-[10px] p-[8px]">
              <img
                className="w-[24px]"
                src={process.env.PUBLIC_URL + "/icons/back.png"}
                alt="back icon"
              />
            </div>
          </Link>
          <div className="flex flex-col">
            <span className="font-Inter font-[400] leading-[16px] text-[#9E9E9E] text-[14px]">
              Snags
            </span>
            <span className="font-Inter font-[700] leading-[30px] text-[24px]">
              Snags
            </span>
          </div>
        </div>
        <div className="font-Inter font-[500] leading-[30px] text-[18px] text-center">
          {opportunityData.id}-{drawing_id}-{opportunityData.opportunity_name}
        </div>
        <Notes
          type="drawing-commercialinvoice-history"
          drawing_id={drawing_id}
        />
      </div>

      <DrawingTabs />

      {loading ? (
        <div className="text-center">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2xl"
            style={{ color: "#55A14A" }}
            spin
          />
        </div>
      ) : (
        <div className="w-full mt-6">
          <div className=" rounded-[12px] p-6">
            <div className="md:flex justify-between items-center p-[12px]">
              <div className="leading-[30px] font-Mulish font-[700] text-[20px] mb-[8px] md:mb-0">
                <span>Snags List</span>
              </div>
            </div>

            <div className="w-[20%] mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="customer_id"
                >
                Customer Filter
              </label>
              <select
                id="customer_id"
                name="customer_id"
                className="w-full bg-white border border-gray-200 rounded-[12px] py-3 px-4 pr-12 leading-tight focus:outline-none focus:border-gray-500"
                onChange={(e) => getCustomer(e.target.value)}
              >
                <option value={""}>Select Customer</option>
                {customer.map((cust) => (
                  <option value={cust.id} key={cust.id}>
                    {cust.customer_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-4">
              <table className="w-full text-sm text-center ">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Opportunity Name</th>
                    <th>Customer Name</th>
                    <th>Location</th>
                    <th>Comments</th>
                    <th>Date Reported</th>
                    <th>Date Completed</th>
                    {/* <th>Before Photo</th>
                    <th>After Photo</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {customerData?.map((data, index) => (
                    <tr key={index} className="border border-gray-200">
                      <td className="text-center border border-gray-200">
                        {data.title}
                      </td>
                      <td className="text-center border border-gray-200">
                        {data.opportunity_name}
                      </td>
                      <td className="text-center border border-gray-200">
                        {data.customer_name}
                      </td>
                      <td className="text-center border border-gray-200">
                        {data.location}
                      </td>
                      <td className="text-center border border-gray-200">
                        {data.comments}
                      </td>
                      <td className="text-center border border-gray-200">
                        {data.date_reported}
                      </td>
                      <td className="text-center border border-gray-200">
                        {data.date_completed}
                      </td>
                      {/* <td className="text-center border border-gray-200">
                        {data.before_photo && (
                          <a href={data.before_photo}>View</a>
                        )}
                      </td>
                      <td className="text-center">
                        {data.after_photo && (
                          <a href={data.after_photo}>View</a>
                        )}
                      </td> */}
                      <td>
                        <div className="text-center">
                          <a
                            href={`/opportunity/${id}/drawing/${drawing_id}/expense-snags/edit/${data.id}`}
                            className="text-center py-[8px] px-[8px] font-[500] font-Inter text-[12px] text-[#55A14A] rounded-[12px] border border-[#55A14A]"
                          >
                            Edit
                          </a>
                          &nbsp;
                          <button
                            className="text-center py-[5px] px-[5px] font-[500] font-Inter text-[12px] text-[#55A14A] rounded-[12px] border border-[#55A14A]"
                            onClick={() => handleDeleteExpenseSnag(data.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            &nbsp;
            <div className="w-full flex justify-end">
              <ReactPaginate
                className="react_pagination_ul"
                breakLabel={
                  <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md mr-4">
                    {"<"}
                  </span>
                }
                nextLabel={
                  <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md">
                    {">"}
                  </span>
                }
                onPageChange={handlePageClick}
                pageCount={Math.ceil(customerData.length / 10)}
                previousLabel={
                  <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md mr-4">
                    {"<"}
                  </span>
                }
                activeClassName="bg-black text-white"
                pageClassName="block text-black  hover:bg-black hover:text-white rounded-md  mr-4"
                pageLinkClassName="w-10 h-10 flex justify-center items-center"
                containerClassName="flex items-center justify-center "
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ExpenseSnagsList;
